// 📁 src/utils/triggerAIPopup.js
import axios from "./axiosInstance";  // ✅ Use JWT-attached axios

export const triggerAIPopup = async ({
  moduleName,
  stepName,
  context,
  userId = "guest",
  ideaId = null,
  recordId = null
}) => {
  try {
    const res = await axios.post("/api/ai-popups", {
      userId,
      ideaId,
      recordId,
      moduleName,
      stepName,
      context
    });

    return res.data?.message || res.data?.tip || null;
  } catch (err) {
    console.warn("AI popup fetch failed:", err.message);
    return null;
  }
};
